/* Hair Monster v10: behavior for hm2-* sections (tabs, finder, shades, picker, product page, drawers) */
(function () {
  'use strict';
  if (window.__hm2) return; window.__hm2 = true;
  var money = function (cents) {
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  };
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  /* ---- generic: one-of-many switchers (guide tabs, finder, shades) ---- */
  function initSwitch(root) {
    if (root.dataset.hm2Ready) return; root.dataset.hm2Ready = '1';
    var btns = $$('[data-hm2-target]', root);
    var isTab = btns.length && btns[0].getAttribute('role') === 'tab';
    function show(btn) {
      btns.forEach(function (b) {
        var on = b === btn;
        if (isTab) { b.setAttribute('aria-selected', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1; }
        else { b.setAttribute('aria-pressed', on ? 'true' : 'false'); }
        var p = document.getElementById(b.getAttribute('data-hm2-target'));
        if (p) p.hidden = !on;
      });
    }
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () { show(b); });
      if (isTab) b.addEventListener('keydown', function (e) {
        var k = e.key, n = null;
        if (k === 'ArrowRight' || k === 'ArrowDown') n = btns[(i + 1) % btns.length];
        if (k === 'ArrowLeft' || k === 'ArrowUp') n = btns[(i - 1 + btns.length) % btns.length];
        if (n) { e.preventDefault(); show(n); n.focus(); }
      });
    });
    $$('[data-hm2-select]', document).forEach(function (a) {
      if (a.dataset.hm2Bound) return; a.dataset.hm2Bound = '1';
      a.addEventListener('click', function () { var b = document.getElementById(a.getAttribute('data-hm2-select')); if (b) b.click(); });
    });
  }

  /* ---- generic drawers ---- */
  var lastOpener = null;
  function openDrawer(id) {
    var ov = document.getElementById(id); if (!ov) return;
    lastOpener = document.activeElement; ov.hidden = false; document.documentElement.style.overflow = 'hidden';
    var f = $('[data-hm2-close]', ov); if (f) f.focus();
  }
  function closeDrawer(ov) {
    ov.hidden = true; document.documentElement.style.overflow = '';
    if (lastOpener && lastOpener.focus) { try { lastOpener.focus(); } catch (e) {} }
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest && e.target.closest('[data-hm2-open]');
    if (o) { e.preventDefault(); openDrawer(o.getAttribute('data-hm2-open')); return; }
    var c = e.target.closest && e.target.closest('[data-hm2-close]');
    if (c) { var ov = c.closest('.hm2-drawer-ov'); if (ov) closeDrawer(ov); return; }
    if (e.target.classList && e.target.classList.contains('hm2-drawer-ov')) closeDrawer(e.target);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('.hm2-drawer-ov').forEach(function (ov) { if (!ov.hidden) closeDrawer(ov); });
  });

  /* ---- "Let us pick for you" quiz ---- */
  function initPicker() {
    var ov = document.getElementById('Hm2Picker'); if (!ov || ov.dataset.hm2Ready) return; ov.dataset.hm2Ready = '1';
    var data; try { data = JSON.parse(document.getElementById('Hm2PickerData').textContent); } catch (e) { return; }
    var body = $('.hm2-pk__body', ov), prog = $('.hm2-pk__progress', ov), stepLbl = $('.hm2-pk__step', ov);
    var EFFORT = { headband: 1, bangbob: 1, glueless: 1.5, upart: 2, lacefront: 3 };
    var PREF = { quick: { 1: 3, 1.5: 2, 2: -99, 3: -99 }, some: { 1: 1, 1.5: 3, 2: 3, 3: -99 }, whole: { 1: 0, 1.5: 2, 2: 1, 3: 3 } };
    var EFF_KEYS = ['quick', 'some', 'whole'];
    var st = { step: 0, ans: {} }, opener = null;
    var arrow = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
    function recommend(o, v, eIdx) {
      var eff = EFF_KEYS[eIdx];
      var scored = data.products.map(function (p, i) {
        var e = PREF[eff][EFFORT[p.type] || 1.5];
        return { p: p, s: (p.occ[o] ? 2 : 0) + (p.vibe[v] ? 2 : 0) + e, i: i };
      }).filter(function (x) { return x.s > -50; });
      scored.sort(function (a, b) { return b.s - a.s || a.i - b.i; });
      return scored.slice(0, 3).map(function (x) { return x.p; });
    }
    function render() {
      var s = st.step, html = '';
      prog.hidden = !(s >= 1 && s <= 3); stepLbl.hidden = prog.hidden;
      $$('.hm2-pk__seg', prog).forEach(function (seg, i) { seg.classList.toggle('on', s >= i + 1); });
      stepLbl.textContent = s + ' of 3';
      if (s === 0) {
        html = '<div class="hm2-pk__intro"><h2 class="hm2-pk__title" id="Hm2PkTitle">' + esc(data.intro_title) + '</h2><p class="hm2-pk__sub">' + esc(data.intro_sub) + '</p><button type="button" class="hm2-btn hm2-btn--primary" data-go="1">' + esc(data.intro_button) + '</button></div>';
      } else if (s <= 3) {
        var q = data.questions[s - 1];
        html = '<h2 class="hm2-pk__title" id="Hm2PkTitle">' + esc(q.title) + '</h2><div class="hm2-pk__opts" role="group" aria-labelledby="Hm2PkTitle">' +
          q.options.map(function (lbl, i) { var on = st.ans[s - 1] === i; return '<button type="button" class="hm2-pk__opt" aria-pressed="' + on + '" data-ans="' + i + '">' + esc(lbl) + arrow + '</button>'; }).join('') +
          '</div><div class="hm2-pk__foot"><button type="button" class="hm2-link" data-back><span>&larr; Back</span></button></div>';
      } else {
        var picks = recommend(st.ans[0], st.ans[1], st.ans[2]);
        if (!picks.length) { html = '<p class="hm2-pk__sub">No match yet.</p>'; }
        else {
          var m = picks[0];
          var accs = (data.acc[m.type] || []).filter(Boolean);
          html = '<h2 class="hm2-pk__title" id="Hm2PkTitle" tabindex="-1">' + esc(data.result_title) + '</h2><p class="hm2-pk__sub">' + esc(data.result_sub) + '</p>' +
            '<div class="hm2-pk__picks">' + [0, 1, 2].map(function (k) { return '<span class="hm2-chip">' + esc(data.questions[k].options[st.ans[k]]) + '</span>'; }).join('') + '</div>' +
            '<div class="hm2-pk__main"><div class="hm2-media hm2-media--contain"><img src="' + esc(m.i) + '" alt="' + esc(m.t) + '" width="600" height="600"></div><div><span class="hm2-pk__label">Our pick</span><p class="hm2-pk__name">' + esc(m.t) + '</p><p class="hm2-pk__price">' + esc(m.p) + '</p><p class="hm2-pk__note">' + esc(data.notes[m.type] || '') + '</p><a class="hm2-btn hm2-btn--primary" href="' + esc(m.u) + '">' + esc(data.view_label) + '</a></div></div>' +
            (picks.length > 1 ? '<p class="hm2-pk__h">Or try</p><div class="hm2-pk__alts">' + picks.slice(1).map(function (a) { return '<a class="hm2-pk__alt" href="' + esc(a.u) + '"><span class="hm2-media hm2-media--contain"><img src="' + esc(a.i) + '" alt="" width="200" height="200"></span><span><b>' + esc(a.t) + '</b><span>' + esc(a.p) + '</span></span></a>'; }).join('') + '</div>' : '') +
            (accs.length ? '<p class="hm2-pk__h">Pairs well with</p><div class="hm2-pk__alts">' + accs.map(function (a) { return '<a class="hm2-pk__alt" href="' + esc(a.u) + '"><span class="hm2-media hm2-media--contain"><img src="' + esc(a.i) + '" alt="" width="200" height="200"></span><span><b>' + esc(a.t) + '</b><span>' + esc(a.p) + '</span></span></a>'; }).join('') + '</div>' : '');
        }
        html += '<div class="hm2-pk__redo"><button type="button" class="hm2-link" data-edit><span>Change my answers</span></button><button type="button" class="hm2-link" data-restart><span>Start over</span></button><a class="hm2-link" href="' + esc(data.shop_url) + '"><span>Just let me shop</span> &rarr;</a></div>';
      }
      body.innerHTML = html;
      var f = s === 0 ? $('[data-go]', body) : s <= 3 ? ($('.hm2-pk__opt[aria-pressed=true]', body) || $('.hm2-pk__opt', body)) : $('#Hm2PkTitle', body);
      if (f) f.focus();
    }
    function open(preset) {
      opener = document.activeElement;
      st = preset ? { step: 4, ans: { 0: preset[0], 1: preset[1], 2: preset[2] } } : { step: 0, ans: {} };
      ov.hidden = false; document.documentElement.style.overflow = 'hidden'; render();
    }
    function close() { ov.hidden = true; document.documentElement.style.overflow = ''; if (opener && opener.focus) { try { opener.focus(); } catch (e) {} } }
    body.addEventListener('click', function (e) {
      var t = e.target.closest('button'); if (!t) return;
      if (t.hasAttribute('data-go')) { st.step = 1; render(); }
      else if (t.hasAttribute('data-ans')) { st.ans[st.step - 1] = +t.getAttribute('data-ans'); st.step++; render(); }
      else if (t.hasAttribute('data-back')) { st.step = Math.max(0, st.step - 1); render(); }
      else if (t.hasAttribute('data-edit')) { st.step = 1; render(); }
      else if (t.hasAttribute('data-restart')) { st = { step: 1, ans: {} }; render(); }
    });
    $('.hm2-pk__close', ov).addEventListener('click', close);
    ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
    ov.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.stopPropagation(); close(); } });
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-hm2-picker]'); if (!b) return;
      e.preventDefault();
      var p = b.getAttribute('data-hm2-picker');
      open(p ? p.split(',').map(Number) : null);
    });
  }

  /* ---- product page ---- */
  function initPdp(root) {
    if (root.dataset.hm2Ready) return; root.dataset.hm2Ready = '1';
    var variants; try { variants = JSON.parse($('[data-hm2-variants]', root).textContent); } catch (e) { variants = []; }
    var form = $('form[data-type="add-to-cart-form"]', root);
    var idInput = form ? $('input[name="id"]', form) : null;
    var qtyInput = $('[data-hm2-qty]', root);
    var atcBtn = form ? $('button[type="submit"]', form) : null;
    var tiers = [[+root.dataset.t1 || 25000, +root.dataset.d1 || 0], [+root.dataset.t2 || 35000, +root.dataset.d2 || 0]];
    var cart = { count: 0, total: 0 };
    window.HM2_TIERS = tiers;
    function current() { var id = idInput ? +idInput.value : 0; return variants.filter(function (v) { return v.id === id; })[0] || variants[0]; }
    function qty() { return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); }
    function tierFor(c) { return c >= tiers[1][0] ? tiers[1][1] : c >= tiers[0][0] ? tiers[0][1] : 0; }
    function update() {
      var v = current(); if (!v) return;
      var line = v.price * qty();
      $$('[data-hm2-price]', document).forEach(function (el) { el.textContent = money(v.price); });
      $$('[data-hm2-vlabel]', document).forEach(function (el) { el.textContent = v.label; });
      $$('[data-hm2-line]', document).forEach(function (el) { el.textContent = money(line); });
      $$('.hm2-len', root).forEach(function (b) { b.setAttribute('aria-pressed', +b.dataset.id === v.id ? 'true' : 'false'); });
      if (atcBtn) {
        var lbl = $('span', atcBtn);
        if (v.available) { atcBtn.removeAttribute('disabled'); if (lbl) lbl.innerHTML = esc(root.dataset.atc || 'Add to bag') + ' &middot; <span data-hm2-line>' + money(line) + '</span>'; }
        else { atcBtn.setAttribute('disabled', 'disabled'); if (lbl) lbl.textContent = 'Sold out'; }
      }
      $$('[data-hm2-satc-btn]', document).forEach(function (b) { b.disabled = !v.available; });
      // progress: the bag when it has items, otherwise this selection
      var base = cart.count ? cart.total : line, who = cart.count ? 'Bag' : 'This set';
      var bar = $('[data-hm2-prog]', root);
      if (bar) {
        var t;
        if (base >= tiers[1][0]) t = money(tiers[1][1]) + ' off unlocked. It applies automatically at checkout.';
        else if (base >= tiers[0][0]) t = money(tiers[0][1]) + ' off unlocked. Add ' + money(tiers[1][0] - base) + ' more for ' + money(tiers[1][1]) + ' off.';
        else t = 'Add ' + money(tiers[0][0] - base) + ' more for ' + money(tiers[0][1]) + ' off at checkout.';
        $('[data-hm2-prog-t]', bar).textContent = t.replace(/\.00/g, '');
        $('[data-hm2-prog-fill]', bar).style.width = Math.min(100, base / tiers[1][0] * 100) + '%';
        $('[data-hm2-prog-who]', bar).textContent = who + ': ' + money(base);
      }
      var pack = $('[data-hm2-pack]', root);
      if (pack) {
        var pc = v.price * 2, pd = tierFor(pc);
        $('[data-hm2-pack-t]', pack).textContent = '2 × ' + v.label + ' for extra fullness';
        $('[data-hm2-pack-s]', pack).textContent = pd ? money(pc) + ' → ' + money(pc - pd) + ' with ' + money(pd).replace('.00', '') + ' off at checkout' : money(pc) + ' · ' + (root.dataset.packTip || '');
        $('button', pack).disabled = !v.available;
      }
    }
    $$('.hm2-len', root).forEach(function (b) {
      b.addEventListener('click', function () {
        if (!idInput) return; idInput.value = b.dataset.id; update();
        try { var u = new URL(location.href); u.searchParams.set('variant', b.dataset.id); history.replaceState({}, '', u.toString()); } catch (e) {}
      });
    });
    $$('[data-hm2-step]', root).forEach(function (b) {
      b.addEventListener('click', function () { qtyInput.value = Math.min(10, Math.max(1, qty() + (+b.getAttribute('data-hm2-step')))); update(); });
    });
    if (qtyInput) qtyInput.addEventListener('input', update);
    function submitWith(n) {
      if (!form) return;
      var prev = qtyInput.value; qtyInput.value = n;
      if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
      setTimeout(function () { qtyInput.value = prev; update(); }, 60);
    }
    var packBtn = $('[data-hm2-pack] button', root);
    if (packBtn) packBtn.addEventListener('click', function () { submitWith(2); });
    $$('[data-hm2-satc-btn]', document).forEach(function (b) { b.addEventListener('click', function () { submitWith(qty()); }); });
    // gallery
    var slides = $$('.hm2-stage__slide', root), thumbs = $$('.hm2-thumb', root), count = $('.hm2-stage__count', root), gi = 0;
    function go(i) {
      if (!slides.length) return; gi = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-on', k === gi); s.setAttribute('aria-hidden', k === gi ? 'false' : 'true'); });
      thumbs.forEach(function (t, k) { t.setAttribute('aria-pressed', k === gi ? 'true' : 'false'); });
      if (count) count.textContent = (gi + 1) + ' / ' + slides.length;
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var pv = $('.hm2-stage__nav.prev', root), nx = $('.hm2-stage__nav.next', root);
    if (pv) pv.addEventListener('click', function () { go(gi - 1); });
    if (nx) nx.addEventListener('click', function () { go(gi + 1); });
    var stage = $('.hm2-stage', root), x0 = null;
    if (stage) {
      stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) { if (x0 == null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) go(gi + (dx < 0 ? 1 : -1)); x0 = null; });
    }
    go(0);
    // delivery estimate from the shipping policy (business days)
    var eta = $('[data-hm2-eta]', root);
    if (eta) {
      var addBiz = function (d, n) { var x = new Date(d.getTime()); while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; } return x; };
      var fmt = function (d) { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); };
      var now = new Date();
      eta.textContent = fmt(addBiz(now, +eta.dataset.min || 3)) + ' – ' + fmt(addBiz(now, +eta.dataset.max || 10));
    }
    // sticky add to bag once the main button scrolls away
    var satc = $('.hm2-satc');
    if (satc && atcBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0]; satc.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
        satc.setAttribute('aria-hidden', satc.classList.contains('is-on') ? 'false' : 'true');
      }).observe(atcBtn);
    }
    // cart totals for the progress bar
    function refreshCart() {
      fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { cart.count = c.item_count || 0; cart.total = c.total_price || 0; update(); })
        .catch(function () {});
    }
    refreshCart();
    if (typeof window.subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') { window.subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refreshCart, 150); }); }
    document.addEventListener('cart:updated', refreshCart);
    update();
  }


  /* ---- spend-more progress inside the theme cart drawer ---- */
  function initCartProgress() {
    var drawer = document.querySelector('cart-drawer'); if (!drawer || drawer.dataset.hm2Prog) return; drawer.dataset.hm2Prog = '1';
    var T = window.HM2_TIERS || [[25000, 0], [35000, 0]], timer = null, busy = false;
    if (!(T[0][1] > 0 || T[1][1] > 0)) return;
    function paint(c) {
      var foot = drawer.querySelector('.drawer__footer'); if (!foot) return;
      var el = foot.querySelector('.hm2-cartprog');
      if (!c.item_count) { if (el) el.remove(); return; }
      if (!el) { el = document.createElement('div'); el.className = 'hm2-cartprog'; el.setAttribute('role', 'status'); foot.insertBefore(el, foot.firstChild); }
      var t = c.items_subtotal_price || c.total_price || 0, msg;
      var f = function (x) { return money(x).replace('.00', ''); };
      if (t >= T[1][0]) msg = f(T[1][1]) + ' off unlocked. It applies automatically at checkout.';
      else if (t >= T[0][0]) msg = f(T[0][1]) + ' off unlocked. Add ' + money(T[1][0] - t) + ' more for ' + f(T[1][1]) + ' off.';
      else msg = 'Add ' + money(T[0][0] - t) + ' more for ' + f(T[0][1]) + ' off at checkout.';
      el.innerHTML = '<p>' + esc(msg) + '</p><div class="hm2-prog__bar" aria-hidden="true"><span class="hm2-prog__fill" style="width:' + Math.min(100, t / T[1][0] * 100) + '%"></span></div>';
    }
    function refresh() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (busy) return; busy = true;
        fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(paint).catch(function () {}).then(function () { busy = false; });
      }, 120);
    }
    new MutationObserver(function () { var foot = drawer.querySelector('.drawer__footer'); if (foot && !foot.querySelector('.hm2-cartprog')) refresh(); }).observe(drawer, { childList: true, subtree: true });
    if (typeof window.subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') { window.subscribe(PUB_SUB_EVENTS.cartUpdate, refresh); }
    refresh();
  }

  function init() {
    $$('[data-hm2-switch]').forEach(initSwitch);
    initPicker();
    $$('[data-hm2-pdp]').forEach(initPdp);
    initCartProgress();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
